import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
  },
  {
    path: '/tips-tricks',
    name: 'tips_tricks',
    component: () => import(/* webpackChunkName: "TipsTricks" */ '../views/TipsTricks.vue')
  },
  {
    path: '/tips-tricks/bear-hunt',
    name: 'tips_tricks_bear_hunt',
    component: () => import(/* webpackChunkName: "TipsTricksBearHunt" */ '../views/TipsTricks/BearHunt.vue')
  },
  {
    path: '/development',
    name: 'development',
    component: () => import(/* webpackChunkName: "Development" */ '../views/Development.vue')
  },
  {
    path: '/map',
    name: 'map',
    component: () => import(/* webpackChunkName: "Map" */ '../views/Map.vue')
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

export default router
